import {Box, Button, FormControl, FormControlLabel, Radio, RadioGroup, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import CompanyBilling from "../../authentication/components/CompanyBilling";
import PersonBilling from "../../authentication/components/PersonBilling";
import {hasFormChanged, zodSubmit} from "../../../utils/FormUtils";
import {useState} from "react";
import DisabledWrapper from "../../../components/DisabledWrapper";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import {z} from "zod";

const schema = z.object({
    incorporation_type: z.enum(["company", "taxable_person"], {
        required_error: "A típus kötelező",
    }),

    name: z.string().min(1, "A számlázási név kötelező"),
    country: z.string().min(1, "Az ország kötelező"),
    state: z.string().min(1, "A megye kötelező"),
    zip: z
        .string()
        .min(1, "Az irányítószám kötelező")
        .regex(/^[0-9]{4}$/, "Az irányítószám 4 számjegy legyen"),
    city: z.string().min(1, "A város kötelező"),
    address: z.string().min(1, "A cím kötelező"),

    // only required if company
    vat_number: z.string().optional(),
})
    .superRefine((values, ctx) => {
        if (values.incorporation_type === "company") {
            if (!values.vat_number || values.vat_number.trim() === "") {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ["vat_number"],
                    message: "Az adószám kötelező vállalkozás esetén",
                });
            }
        }
    });


const InvoiceData = ({data, handleSubmit}) => {
    const [errors, setErrors] = useState({});
    const [isDirty, setIsDirty] = useState(false);
    const [incorporationType, setIncorporationType] = useState(data?.incorporation_type);


    return <form
        onSubmit={e => setIsDirty(!zodSubmit(e, setErrors, handleSubmit, schema))}
        onChange={e => setIsDirty(hasFormChanged(e.currentTarget, data))}
    >
        <Stack spacing={2}>


            <FormControl>
                <RadioGroup
                    name="incorporation_type"
                    value={incorporationType}
                    onChange={(e) => setIncorporationType(e.target.value)}
                    sx={{my: 1}}
                >
                    <FormControlLabel
                        value="company"
                        control={<Radio/>}
                        label={<Typography
                            color='#6F8E9A'
                            variant='caption'>
                            Vállalkozás
                        </Typography>}/>

                    <FormControlLabel
                        value="taxable_person"
                        control={<Radio/>}
                        label={<Typography
                            color='#6F8E9A'
                            variant='caption'>
                            Magánszemély
                        </Typography>}/>
                </RadioGroup>
            </FormControl>
            {incorporationType === 'company' ?
                <CompanyBilling data={data} errors={errors}/>
                :
                <PersonBilling data={data} errors={errors}/>
            }
            <Box sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'flex-end'
            }}>
                <DisabledWrapper disabledCause={[{
                    disabled: !isDirty,
                    message: 'Módosítsd a mezőket a mentéshez!'
                }]}>
                    <Button
                        endIcon={<SaveRoundedIcon/>}
                        type="submit"
                        variant='contained'
                    >
                        Mentés
                    </Button>
                </DisabledWrapper>
            </Box>

        </Stack>
    </form>
}

export default InvoiceData